// extracted by mini-css-extract-plugin
module.exports = {"cnt":"Metric_cnt__2Faug","withicon":"Metric_withicon__2sIFG","icon":"Metric_icon__cA8Yk","info":"Metric_info__2NOZ2","n":"Metric_n__2Gu9w","title":"Metric_title__2_A_v"};